import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const ListIcon = ({ color = "purple" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 10H17M14 6H21M14 14H21M14 18H17M3 10H10V6H3V10ZM3 14H10V18H3V14Z"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ListIcon;
